// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#333","menuActiveText":"#4079fc","subMenuActiveText":"#333","menuBg":"#fff","menuHover":"#d1dffe","subMenuBg":"#fff","subMenuHover":"#d1dffe","sideBarWidth":"200px"};